import { HYDRATE } from 'next-redux-wrapper';

import { RootState } from '../store';
import {
    UPDATE_CURRENT_SORT_ORDER,
    INITIALISE,
    RESET_SORT_ORDER,
    RawSortOrderData,
    ListingsSortOrderState,
    InitialiseSortOrderAction,
    ListingsSortActionTypes
} from './listingsSortOrder.types';

const optionsText: { [key: string]: string } = {
    mostRecent: 'Most recent',
    highestPrice: 'Highest price',
    lowestPrice: 'Lowest price',
    mostReduced: 'Most reduced',
    mostPopular: 'Most popular'
};

// helpers
const convertRawSortOrderData = (sortOrderData: RawSortOrderData) => {
    const { options: rawOptions, currentSortOrder } = sortOrderData;

    const options = rawOptions.map((option) => {
        const { i18NLabelKey, value } = option;
        return {
            label: optionsText[i18NLabelKey],
            value
        };
    });

    return {
        options,
        currentSortOrder
    };
};

// Actions
export const initialiseSortOrder = (
    sortOrderData: RawSortOrderData
): InitialiseSortOrderAction => ({
    type: INITIALISE,
    sortOrderData
});

export const updateCurrentSortOrder = (currentSortOrder: string) => ({
    type: UPDATE_CURRENT_SORT_ORDER,
    currentSortOrder
});

export const resetSortOrder = () => ({
    type: RESET_SORT_ORDER
});

// Reducer
// Should be refactored in line with filters, so we don't depend on the backend
// to give us sort options
// "newest_listings" currently hardcoded as the default so the value is in the
// URL when coming from the homeapge
const initialState: ListingsSortOrderState = {
    currentSortOrder: 'newest_listings',
    options: []
};

export const listingsSortOrder = (
    state = initialState,
    action: ListingsSortActionTypes
): ListingsSortOrderState => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.listingsSortOrder
            };
        }
        case INITIALISE: {
            const { sortOrderData } = action;

            const { options, currentSortOrder } = convertRawSortOrderData(
                sortOrderData
            );

            return {
                ...state,
                options,
                currentSortOrder
            };
        }
        case UPDATE_CURRENT_SORT_ORDER: {
            const { currentSortOrder } = action;

            return {
                ...state,
                currentSortOrder
            };
        }
        case RESET_SORT_ORDER: {
            return {
                ...state,
                currentSortOrder: 'newest_listings'
            };
        }
        default:
            return {
                ...state
            };
    }
};

// Selectors
const selectListingsSort = (state: RootState): ListingsSortOrderState =>
    state.listingsSortOrder;

export const selectSortOrderOptions = (state: RootState) =>
    selectListingsSort(state).options;
export const selectCurrentSortOrder = (state: RootState) =>
    selectListingsSort(state).currentSortOrder;

export default listingsSortOrder;
